<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height overflow-y-hidden">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle">
          <template v-slot:body>
            <v-row no-gutters>
              <v-col cols="12" class="pa-0">
                <v-row no-gutters>
                  <v-col class="pb-1">
                    <i-card-top
                      class="d-md-flex"
                      outlined
                      :useBtnList="useBtnList"
                      :customBtnList="customBtnList"
                      :class="[setBtnColor]"
                      @btnSave="btnSave()" @btnPrint="btnPrint()" @btnDelete="btnDelete()"
                      @btnSaveAsExcel="btnSaveAsExcel()"
                    >
                      <template v-slot:body>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <i-label :label="'Request No :'" />
                          <v-col cols="2">
                            <v-select
                              v-model="resNo"
                              :items="resNoList"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="btnRetrieve()"
                            />
                          </v-col>
                          <i-label :label="'Warehouse :'" class="pl-2"/>
                          <v-col cols="2">
                            <v-select
                              v-model="whNo"
                              :items="whNoList"
                              return-object
                              item-text="codeName"
                              item-value="code"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="btnRetrieve()"
                            />
                          </v-col>
                          <i-label :label="'Location :'" class="pl-2"/>
                          <v-col cols="2">
                            <v-select
                              v-model="locNo"
                              :items="locNoList"
                              single-line
                              outlined
                              dense
                              height="32"
                            />
                          </v-col>
                        </v-row>
                      </template>
                    </i-card-top>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="3" class="top">
                    <v-row no-gutters>
                      <v-col cols="5" align="right" class="pt-2 pb-2"><span class="pa-2 search">Carry Out Date: </span></v-col>
                      <v-col cols="5" class="pt-1">
                        <DxDateBox
                          :value="plnCarryOutDte"
                          height="30px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {plnCarryOutDte = e.value}"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3" class="top">
                    <v-row no-gutters>
                      <v-col cols="4" align="right" class="pt-2 pb-2"><span class="pa-2 search">Car No : </span></v-col>
                      <v-col cols="6" class="pt-1">
                        <v-autocomplete
                          v-model="carNo"
                          :items="carNoList"
                          return-object
                          item-value="code"
                          item-text="codeName"
                          single-line
                          outlined
                          dense
                          height="32"/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="6" class="top">
                    <v-row no-gutters>
                      <v-col cols="4" align="right" class="pt-2 pb-2"><span class="pa-2 search">Driver Name : </span></v-col>
                      <v-col cols="5" class="pt-1">
                        <v-select
                          v-model="perNo"
                          :items="perNoList"
                          return-object
                          item-value="code"
                          item-text="codeName"
                          single-line
                          outlined
                          dense
                          height="32"/>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col class="pt-1">
                    <!-- class="doubleListBox01" -->
                    <DxDataGrid
                      height="250"
                      id="gridMain"
                      :ref="gridMainRef"
                      :data-source="gridMainList" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="false"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"
                    >
                      <DxPaging :enabled="false" />
                      <DxPager :visible="false" />

                      <DxColumn data-field="resSeq" caption="Seq." width="3%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="shipNo" caption="Ship No" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="porNoSeq" caption="POR No" width="7%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="partNo" caption="Part No" width="7%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="partSpec" caption="Material Specification" width="63%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="resQty" caption="Qty" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="matlUnit" caption="Unit" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="issueShip" width="5%" alignment="center" :allow-editing="false" header-cell-template="Issue" />
                      <template #Issue>
                        <div>Issue<br>Ship No</div>
                      </template>
                      <DxColumn data-field="block" caption="Block" width="5%" alignment="center" :allow-editing="false" />

                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" class="pt-2">
                <v-row no-gutters>
                  <v-col class="">
                    <i-card-top
                      class="d-md-flex"
                      outlined
                    >
                      <template v-slot:body>
                        <v-row no-gutters class="center pa-2">
                          <i-label :label="' Ship No :'" />
                          <v-col cols="1">
                            <v-select
                              v-model=" shipNo"
                              :items="shipNoList"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="getBlockList()"
                            />
                          </v-col>
                          <i-label :label="' Block :'" class="pl-2"/>
                          <v-col cols="1">
                            <v-select
                              v-model="block"
                              :items="blockList"
                              outlined
                              dense
                              height="32"
                              @change="getMain2()"
                              />
                          </v-col>
                          <i-label :label="' Maker :'" class="pl-2"/>
                          <v-col cols="2">
                            <v-select
                              v-model="makerNm"
                              :items="makerNmList"
                              return-object
                              item-text="codeName"
                              item-value="code"
                              outlined
                              dense
                              height="32"
                              @change="getMain2()"
                              />
                          </v-col>
                          <v-col class="pa-1 pl-4">
                            <span class="pa-1 subText" style="background-color: #C0E0FF;">Requested(신청완료)</span>
                            <span class="pa-1 subText" style="background-color: #FF4040;">No have Stock(재고부족)</span>
                            <span class="pa-1 subText" style="background-color: #FFFFFF;">Not yet Request(신청전)</span>
                          </v-col>
                        </v-row>
                      </template>
                    </i-card-top>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col class="pt-1">
                    <DxDataGrid
                      class="doubleListBox07"
                      id="gridMain2"
                      :ref="gridMain2Ref"
                      :data-source="gridMainList2" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="false"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"
                      :selection="{ mode: 'none'}"
                      @cellPrepared="cellPrepared"
                      @editingStart="editingStart"
                      >
                      <DxPaging :enabled="false"/>
                      <DxPager :visible="false" />

                      <DxColumn data-field="selYn" data-type="boolean" width="2%" header-cell-template="selHeader" cell-template="selChkRow" :allow-editing="false" />
                      <template #selHeader = "{ data: cellInfo }" >
                        <DxCheckBox :value="false" :onValueChanged="value => onValueChanged(value, cellInfo)"  />
                      </template>
                      <template #selChkRow = "{ data: cellInfo }">
                        <DxCheckBox :value="cellInfo.value === 'Y' ? true : false"
                          :onValueChanged="value => onValueChanged2(value, cellInfo)"
                          :disabled="cellInfo.data.disabled == 'Y' ? true : false" 
                        />
                      </template> 

                      <DxColumn data-field="block" caption="Block" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn caption="Activity" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="mact" caption="POR No" width="7%" alignment="center" :allow-editing="false" />
                      </DxColumn>
                      <DxColumn caption="Mid P.S.D" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="psdDte" caption="Exe P.F.D" width="5%" alignment="center" :allow-editing="false" />
                      </DxColumn>
                      <DxColumn data-field="fastDte" caption="FAST P.S.D" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn caption="COCW" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="cocw" caption="Stage" width="5%" alignment="center" :allow-editing="false" />
                      </DxColumn>
                      <DxColumn caption="Material Code" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="matlCd" caption="Part No" width="7%" alignment="center" :allow-editing="false" />
                      </DxColumn>
                      <DxColumn data-field="partSpec" caption="Material Specification" width="29%" alignment="center" :allow-editing="false" />
                      <DxColumn caption="Part Qty" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="partQty" caption="Last Req" width="5%" alignment="center" :allow-editing="false" />
                      </DxColumn>
                      <DxColumn data-field="matlUnit" caption="Unit" width="3%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="partUnitWgt" width="5%" alignment="center" :allow-editing="false" header-cell-template="Unit" />
                      <template #Unit>
                        <div>Unit<br>Weight</div>
                      </template>
                      <DxColumn data-field="stoQty" width="5%" alignment="center" :allow-editing="false" header-cell-template="Stock" />
                      <template #Stock>
                        <div>Stock<br>Qty</div>
                      </template>
                      <DxColumn data-field="resQty" width="5%" alignment="center" header-cell-template="Request" />
                      <template #Request>
                        <div>Request<br>Qty</div>
                      </template>
                      <DxColumn alignment="center" :allow-editing="false" header-cell-template="Waiting" >
                        <DxColumn data-field="waitingConfQty" caption="Availble Q'ty" width="7%" alignment="center" :allow-editing="false" />
                      </DxColumn>
                      <template #Waiting>
                        <div>Waiting<br>Conf.Qty</div>
                      </template>
                      <DxColumn caption="W.H Date" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="whDte" caption="Issue Date" width="7%" alignment="center" :allow-editing="false" />
                      </DxColumn>

                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { getCarList , getDriverList } from '@/api/view/hip/common/common.js'
import { getShipNoList } from '@/api/view/hip/A/epmsa010_kl'
import { getResNoList,getLocNoList,epmsa022head,epmsa022detail,epmsa021Block,epmsa023List,
  epmsa020save , epmsa020delete , epmsa022xls } from '@/api/view/hip/A/epmsa020'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { reportView } from '@/api/view/hip/common/common'
import notify from 'devextreme/ui/notify'
import dayjs from 'dayjs';

export default {
  name: 'epmsa020',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox,
  },
  data() {
    return {
      makerCd: this.$store.state.user.makerCd,
      userId: this.$store.state.user.userId,
      menuTitle: this.$route.meta.title,
      gridMainRef: 'gridMainRef',
      gridMain2Ref: 'gridMain2Ref',

      useBtnList: ['btnSave','btnPrint', 'btnSaveAsExcel','btnDelete'],
      customBtnList: [
        { id: 'btnSaveAsExcel', text: 'Save as Excel', icon: 'excel' }
      ],
      setBtnColor: 'setBtnColor',

      resNo: '',
      resNoList: [],
      whNo: '',
      whNoList: [],
      locNo: '',
      locNoList: [],


      carNo: '',
      carNoList: [],
      perNo: '',
      perNoList: [],
      shipNo: '',
      shipNoList: [],
      block: '',
      blockList: [],
      makerNm: '',
      makerNmList: [],

      plnCarryOutDte: '',
      remark: '',

      gridMainList: [],
      gridMainList2: [],

      editingGbn: false,
      saveResNo: ''
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.gridMainRef)
    },
    gridInstance2() {
      return this.GetDataGrid(this.gridMain2Ref)
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.gridInstance.option('defaultPaging', false)
      this.gridInstance2.option('defaultPaging', false)
      this.getResNoList()
      this.getList()
    },
    async getResNoList(saveResNo){
      this.resNoList = []
      let param = {
        makerCd: this.makerCd
      }
      await getResNoList(param).then(res => {
        this.resNoList.push('New')
        res.list.forEach(e => {
          this.resNoList.push(e.resNo)
        });
        if(saveResNo){
          this.resNo = saveResNo
        } else {
          this.resNo = this.resNoList[0]
        }
      })
    },
    async getList(){
      try {
        this.openLoading('searching')
        let param = {
          makerCd: this.makerCd
        }
        await getCmChildCode({
          code: '',
          codegr: '',
          prtCode: 'WH_NO',
          userFlag: 'Y'
        }).then(res => {
          this.whNoList = res.list
          this.whNo = this.whNoList[0]
        })
        await getCmChildCode({
          code: '',
          codegr: '',
          prtCode: 'MAKER_NAME',
          userFlag: 'Y'
        }).then(res => {
          this.makerNmList = res.list
          this.makerNm = this.makerNmList[0]
        })

        await getCarList(param).then(res => {
          this.carNoList.push({code: '' , codeName: ''})
          res.list.forEach(e => {
            e.code = e.carNo
            e.codeName = e.carLicense
            this.carNoList.push(e)
          });
          this.carNo = this.resNoList[0]
        })

        await getDriverList(param).then(res => {
          this.perNoList.push({code: '' , codeName: ''})
          res.list.forEach(e => {
            e.code = e.perNo
            e.codeName = !e.perEnm ? '' : e.perEnm
            this.perNoList.push(e)
          });
          this.perNo = this.perNoList[0]
        })

        await getShipNoList(param).then(res => {
          this.shipNoList.push('Select')
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
          this.shipNo = this.shipNoList[0] 
        })
      } finally {
        this.getLoc()
        this.endLoading()
      }
    },
    async getLoc(){
      this.locNoList = []
      let param = {
        resNo: this.resNo == 'New' ? '' : this.resNo,
        whNo: this.whNo.code,
      }
      await getLocNoList(param).then(res => {
        this.locNoList.push('')
        res.list.forEach(e => {
          this.locNoList.push(e.locNo)
        });
        this.locNo = this.locNoList[0]
      })
    },
    btnRetrieve() {
      this.getLoc()
      this.getMain()
    },
    async getMain(saveResNo){
      try {
        let res = ''
        if(saveResNo){
          res = saveResNo
        } else {
          res = this.resNo
        }
        this.openLoading('searching')
        let param = {
          resNo: res,
          whNo: this.whNo.code,
          locNo: this.locNo,
        }
        await epmsa022head(param).then(res => {
          if(res.list.length > 0){
            this.plnCarryOutDte = res.list[0].plnCarryOutDte
            this.remark = !res.list[0].remark ? '' : res.list[0].remark
            this.carNoList.forEach(e => {
              if(res.list[0].carNo == e.code){
                this.carNo = {code: res.list[0].carNo , codeName: e.codeName}
              }
            });
          }
        })

        await epmsa022detail(param).then(res => {
          let cnt = 0
          res.list.forEach(e => {
            e.id = cnt++
            e.porNoSeq = e.porNo + '-' + e.porSeq
          });
          this.gridMainList = res.list
        })
      } finally {
        this.endLoading()
      }
    },
    async getBlockList(){
      let param = {
        shipNo: this.shipNo === 'Select' ? '' : this.shipNo,
        makerCd: this.makerCd
      }
      this.openLoading('searching')
      await epmsa021Block(param).then(res => {
        this.blockList = []
        this.blockList.push('')
        res.list.forEach(e => {
          this.blockList.push(e.block)
        });
        this.block= this.blockList[0]
      }).finally(() => {
        this.getMain2()
        this.endLoading()
      })
    },
    async getMain2(){
      try {
        this.openLoading('searching')
        this.gridMainList2 = []
        let param = {
          makerCd: this.makerCd,
          shipNo: this.shipNo === 'Select' ? '' : this.shipNo,
          block: this.block,
          makerNm: this.makerNm.code,
        }
        await epmsa023List(param).then(res => {
          if(res.list.length > 0){
            let cnt = 0
            let count = 0
            res.list.forEach(e => {
              e.id = cnt
              e.count = count++
              e.partUnitWgt = e.partUnitWgt == '0' ? '' : e.partUnitWgt
              e.resQty = '0'
              e.selYn = 'N'
              let disabled = ''
              if(e.partQty > e.prvResQty){
                if(e.fabItemYn == 'Y'){
                  disabled = ''
                }else {
                  if(Number(e.stoQty) > 0){
                    if(Number(e.stoQty) < Number(e.partQty)){
                      disabled = 'Y'
                    }
                  } else {
                    disabled = 'Y'
                  }
                }
              } else {
                disabled = 'Y'
              }
              e.disabled = disabled
              this.gridMainList2.push(e)
              this.gridMainList2.push({
                id: cnt++,
                mact: e.stockYn == 'Y' ? 'STOCK' : e.porNo + '-' + e.porSeq,
                psdDte: e.pfdDte,
                cocw: e.stageCd,
                matlCd: e.partNo,
                partQty: e.prvResQty,
                waitingConfQty: e.availableQty,
                whDte: e.issueDte,
                selYn: 'N',
                count: count++,
                prvResQty: e.prvResQty,
                partQty: e.partQty,
                stoQty: e.stoQty,
                fabItemYn: e.fabItemYn
              })
            })
            // this.gridMainList2 = res.list
          }
        })
      } finally {
        this.endLoading()
      }
    },
    async btnSave(){
      if(!this.plnCarryOutDte){
        this.vToastify(this.$t("Select Carry Out Date."), 'warn')
        return
      }
      if(!this.carNo.code){
        this.vToastify(this.$t("Input Car No."), 'warn')
        return
      }
      if(!this.perNo.code){
        this.vToastify(this.$t("Input Driver Name."), 'warn')
        return
      }

      let cnt = 0
      let param = []
      if(this.gridMainList2.length > 0){
        for(var row of this.gridMainList2){

          if(row.selYn == 'Y'){
            row.carNo = this.carNo.code
            row.userId = this.userId
            row.perNo = this.perNo.code
            row.makerCd = this.makerCd
            row.plnCarryOutDte = dayjs(this.plnCarryOutDte).format('YYYY-MM-DD')
            row.div = 'T30E_1119'

            param.push(row)
          }
        }
      } else {
        this.vToastify(this.$t("Select data."), 'warn')
        return
      }
      try {
        this.openLoading('searching')
        this.vToastifyPrompt(
          this.$t('Do you want to save the data?'),
          'info',
            current => {
              epmsa020save(param)
                .then(res => {
                  const result = res.body.substring(0,1)
                  this.saveResNo = res.body.substring(1)
                  if(result == 'Y'){
                    notify(this.$t('Saving is completed.'), 'success', 3000)
                  } else {
                    this.vToastify(this.$t(res.body), 'warn')
                  }
                })
                .catch(error => {
                  this.vToastify(error, 'warn')
                  this.endLoading()
                })
                .finally(() => {
                  this.plnCarryOutDte = ''
                  this.carNo = ''
                  this.gridInstance2.clearSelection()
                  this.getResNoList(this.saveResNo)
                  this.getMain(this.saveResNo)
                  this.getMain2()
                })
            },
          null,
          true
        )
      } finally {
        this.endLoading()
      }
    },
    btnPrint(){
      if(!this.resNo){
        this.vToastify(this.$t("Select Request No."), 'warn')
        return
      }
      const param = {
        fileName: 'epmsa020.jrxml',
        //fileName: 'epmsa020.jasper',
        as_res_no: this.resNo,
        as_wh_no: this.whNo.code,
        as_loc_no: this.locNo,
      }
      console.log(param)
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    async btnDelete(){
      await this.gridInstance.saveEditData()
      var selectedMainRows = await this.gridInstance.getSelectedRowsData()

      if(!selectedMainRows.length){
        this.vToastify(this.$t("Data is not selected for delete."), 'warn')
        return
      }

      for(var row of selectedMainRows){
        row.div = 'T30E_1119'
        row.userId = this.userId
        // row.appNo = !row.appNo ? '' : row.appNo
      }
      try {
        this.openLoading('searching')
        this.vToastifyPrompt(
          this.$t('Do you want to delete?'),
          'info',
            current => {
              epmsa020delete(selectedMainRows)
                .then(res => {
                  const result = res.body
                  if(result == 'Y'){
                    notify(this.$t('Delete is complete.'), 'success', 3000)
                  } else {
                    this.vToastify(this.$t(result), 'warn')
                  }
                })
                .catch(error => {
                  this.vToastify(error, 'warn')
                  this.endLoading()
                })
                .finally(() => {
                  this.plnCarryOutDte = ''
                  this.carNo = ''
                  this.gridInstance.clearSelection()
                  this.getResNoList()
                  this.getLoc()
                  this.getMain()
                  this.getMain2()
                })
            },
          null,
          true
        )
      } finally {
        this.endLoading()
      }
    },
    btnSaveAsExcel(){
      if(!this.resNo){
        this.vToastify(this.$t("Select Request No."), 'warn')
        return
      }
      const param = {
        resNo: this.resNo,
        whNo: this.whNo.code,
        locNo: this.locNo,
      }
      epmsa022xls(param)
    },
    onValueChanged(value, cellInfo){
      for(let i = 0; i < this.gridMainList2.length; i++) {
        let gbn = this.gridMainList2[i]
        if(gbn.disabled != 'Y'){
          if(i % 2 === 0){
            if(value.value === true) {
              this.gridMainList2[i].selYn = 'Y'
              this.gridMainList2[i].resQty = Number(this.gridMainList2[i].partQty) - Number(this.gridMainList2[i].prvResQty )

            } else {
              this.gridMainList2[i].selYn = 'N'
              this.gridMainList2[i].resQty = '0'
            }
          }
        }
      }
    },
    onValueChanged2(value, cellInfo){
      if(cellInfo.data.selYn == 'N') {
        this.gridMainList2[cellInfo.data.count].selYn = 'Y'
        this.gridMainList2[cellInfo.data.count].resQty = Number(cellInfo.data.partQty) - Number(cellInfo.data.prvResQty)
      } else {
        this.gridMainList2[cellInfo.data.count].resQty = '0'
        this.gridMainList2[cellInfo.data.count].selYn = 'N'
      }
    },
    async editingStart(e){
      if(e.column.dataField === 'resQty' && e.data.selYn == 'N' ){
        e.cancel = true
      } else {
        e.cancel = false
      }
    },
    async cellPrepared(e){
      if(e.rowType === 'header'){

      } else {
        if(e.data.prvResQty == e.data.partQty){
          e.cellElement.style.backgroundColor = '#C0E0FF'
        }else if(Number(e.data.stoQty) < Number(e.data.partQty)){
          if(e.data.fabItemYn != 'Y'){
            e.cellElement.style.backgroundColor = '#FF4040'
          }
        }

        if(e.column.dataField == 'block' || e.column.dataField == 'fastDte' || e.column.dataField == 'partSpec' || e.column.dataField == 'matlUnit'
        || e.column.dataField == 'partUnitWgt' || e.column.dataField == 'stoQty' || e.column.dataField == 'resQty') {
          if(e.rowIndex % 2 == 0){
            e.cellElement.setAttribute('rowspan', 2)
          } else {e.cellElement.style.display = 'none'}
        }

        if(e.columnIndex == 0 && e.rowIndex % 2 == 0){
          e.cellElement.setAttribute('rowspan', 2)
        } else if(e.columnIndex == 0 && e.rowIndex % 2 != 0){
          e.cellElement.style.display = 'none'
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.search{
  font-weight: bold;
  color: black;
}
.top{
  background-color: #C0E0FF;
  border-left: 1px solid #B4BAC6;
}
.top2{
  background-color: #C0E0FF;
  border-top: 1px solid #B4BAC6;
}
.subText {
  border: 1px solid #B4BAC6;
  color: black;
}
$redBtn: #FF0000;
.setBtnColor::v-deep {
  [role=btnDelete]{
    .v-btn__content {
      div {
        color: #{$redBtn} !important;
      }

      i {
        color: #{$redBtn} !important;
      }
    }
  }
}
</style>
